import React from 'react';
import SystemPlanHeader from './SystemPlanHeader';
import SystemPlanFeatures from './SystemPlanFeatures';
import SystemPlanActions from './SystemPlanActions';

import { useSystemPlans } from '../../hooks/system/useSystemPlans';
import { PlanSimpleDTO } from '../../types/plans/Plans';

interface Props {
  plan: PlanSimpleDTO;
  onChangePlan: (code: string) => void;
}

const SystemPlanRow: React.FC<Props> = ({ plan, onChangePlan }) => {
  const {
    editingFeatures,
    editingPlanCode,
    loadPlanFeatures,
    onToggleFeature,
    clearEditing,
    isLoadingFeatures,
    updatingFeatureCodes,
  } = useSystemPlans();

  /**
   * 🧠 Fuente de verdad
   */
  const isEditing = editingPlanCode === plan.code;

  /**
   * 🔥 Entrar en edición
   */
  const handleEdit = async () => {
    if (editingPlanCode && editingPlanCode !== plan.code) {
      clearEditing();
    }

    await loadPlanFeatures(plan.code);
  };

  return (
    <div
      className={`
relative mb-6 w-full rounded-sm border p-6 shadow-default transition
${
  plan.active
    ? 'border-primary bg-blue-50 before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:rounded-l-sm before:bg-primary dark:bg-blue-900/10'
    : 'border-stroke dark:border-strokedark'
}
bg-white dark:bg-boxdark
`}
    >
      {/* 🔹 HEADER */}
      <SystemPlanHeader
        name={plan.name}
        code={plan.code}
        active={plan.active}
        featureCount={plan.featureCount}
        onChangePlan={onChangePlan}
        onEdit={handleEdit}
        editing={isEditing}
      />

      {/* 🔹 LOADING */}
      {isLoadingFeatures && (
        <div className="text-gray-500 mt-4 text-sm">
          Cargando funcionalidades...
        </div>
      )}

      {/* 🔹 FEATURES */}
      {!isLoadingFeatures && isEditing && (
        <SystemPlanFeatures
          features={editingFeatures}
          editing={isEditing}
          onToggle={(featureCode) =>
            void onToggleFeature(plan.code, featureCode)
          }
          updatingFeatureCodes={updatingFeatureCodes}
        />
      )}

      {/* 🔹 ACTIONS */}
      {isEditing && (
        <SystemPlanActions
          loading={isLoadingFeatures || updatingFeatureCodes.length > 0}
          onClose={clearEditing}
        />
      )}
    </div>
  );
};

export default SystemPlanRow;
